import m from "mithril";
import _ from "underscore";
import {QuestionaryVariable} from "./questionary";

function cast(value: any, type: string) {
	if(_.isUndefined(value) || value === null){
		return value;
	}
	if(type === "number"){
		return Number(value);
	}
	return value;
}

// used to suspend redraw on variable change, TODO: consider removing redraw from variable completely
var globalRedraw = true;


// state is factory method for getter-setter same as mithril m.prop (http://lhorie.github.io/mithril/mithril.prop.html)
// with these changes:
// 	- if redraw parameter is set every time variable changes mithril redraw is triggered
//  - any function bound by bind(state, [function1, function2, ...]) is called when state value changes
//  - undefined and null are not serialized into JSON

export interface ReactiveProperty<T> {
	(): T;
	(a: T): void;
	toJSON: () => any;
	updates: (() => void)[];
}

export function state(store: any, type: string, redraw: boolean): ReactiveProperty<any> {
	var prop = <ReactiveProperty<any>> function() {
		if (arguments.length){
			const newValue = cast(arguments[0], type);
			if(store !== newValue){
				store = newValue;
                _.each(prop.updates, u => u());

                if(redraw && globalRedraw){
                    m.redraw();
                }
			}
		}
		return store;
	};

	prop.toJSON = () => {
		// return undefined for null so it is not stored
		if (store === null) {
			return;
		}
		return store;
	};
	prop.updates = [];
	return prop;
}

export function stopRedraw(){ globalRedraw = false; }
export function startRedraw(){ globalRedraw = true; }

export function bind(f: any, states: QuestionaryVariable<any>[]){
	_.each(states, (state:ReactiveProperty<any>) => {
	    state.updates.push(f);
		// run function to init right value
		f();
	});
}
